<template>
   <div class="bg-white shadow-invert" id="product_info">
      <div class="max-w-(--breakpoint-2xl) mx-auto px-6 lg:px-4">
         <nav class="py-2 space-x-4 hidden lg:flex" id="product-info-navbar" aria-label="Global">
            <div class="container flex">
               <span @click="$scrollTo('#plusminus', 500)" class="product-nav-link"> Product informatie</span>

               <span
                  @click="$scrollTo('#product-reviews', 500)"
                  class="product-nav-link"
                  v-if="product.reviews.reviews.length"
               >
                  Reviews</span
               >

               <span
                  @click="$scrollTo('#meegeleverd', 500)"
                  class="product-nav-link"
                  v-if="!product.reorder_type && product.type == 'configurable'"
               >
                  Meegeleverd
               </span>

               <span
                  @click="$scrollTo('#knoppen', 500)"
                  class="product-nav-link"
                  v-if="product.reorder_type != 2 && product.type == 'configurable'"
               >
                  Opties
               </span>

               <span
                  @click="$scrollTo('#tekeningen', 500)"
                  class="product-nav-link"
                  v-if="Object.keys(techimages).length"
               >
                  Technische tekeningen
               </span>
               <span @click="$scrollTo('#specs', 500)" class="product-nav-link"> Specificaties </span>
               <span @click="$scrollTo('#faq', 500)" class="product-nav-link" v-if="product.faq"> FAQ </span>
            </div>
         </nav>
      </div>
   </div>

   <div class="bg-white border-t border-gray-100">
      <div class="max-w-(--breakpoint-2xl) mx-auto px-6 lg:px-4 py-4">
         <div id="product-info">
            <!-- Plus- en minpunten -->
            <div id="plusminus" class="w-full flex flex-wrap pb-6 mb-6 border-b border-gray-200">
               <div class="w-full md:w-1/2 my-2 md:pr-12">
                  <Collapse :when="isExpanded" class="v-collapse relative" :baseHeight="220">
                     <div class="absolute h-32 w-full bottom-0" v-if="!isExpanded">
                        <div class="w-full h-20 bg-linear-to-t from-white"></div>
                        <div class="w-full h-12 bg-white"></div>
                     </div>
                     <p class="mt-1 mb-4 styled pb-12" v-html="product.description"></p>
                     <button
                        class="absolute bottom-0 left-1/2 -translate-x-1/2 button default"
                        @click="isExpanded = !isExpanded"
                     >
                        <span v-if="isExpanded">Lees minder</span>
                        <span v-else>Lees meer</span>
                     </button>
                  </Collapse>

                  <div v-if="Object.keys(product.plus).length">
                     <strong class="text-xl mb-3 mt-8 inline-block">Plus- en minpunten</strong>

                     <!-- Plus -->
                     <div class="w-full" v-if="product.plus">
                        <ul class="reset-list">
                           <li v-for="plus in product.plus" :key="plus" class="flex items-center">
                              <fa :icon="['fas', 'plus-circle']" class="text-green-500 mx-2 shrink" />
                              <div class="flex">{{ plus }}</div>
                           </li>
                        </ul>
                     </div>

                     <!-- Minus -->
                     <div class="w-full" v-if="product.minus">
                        <ul class="reset-list">
                           <li v-for="minus in product.minus" :key="minus" class="flex items-center">
                              <fa :icon="['fas', 'minus-circle']" class="text-gray-400 mx-2 shrink" />
                              <div class="flex">{{ minus }}</div>
                           </li>
                        </ul>
                     </div>
                  </div>

                  <!-- Meegeleverd -->
                  <div id="meegeleverd" class="pt-8 mt-8 border-t border-gray-200 md:pr-12" v-if="isCylinder(product)">
                     <h2 class="text-xl font-bold inline-block mb-2">Standaard meegeleverd</h2>
                     <span class="block"
                        >Bij een
                        <strong>set van {{ cylinderQty }} cilinder{{ cylinderQty > 1 ? 's' : '' }}</strong></span
                     >
                     <div class="flex flex-wrap">
                        <ul class="list-disc list-inside mt-2 pl-4 w-full md:w-1/2">
                           <li>Cilinders ({{ cylinderQty }})</li>
                           <li>Sleutels ({{ keyQty }})</li>
                           <li>Cilinder schroeven ({{ cylinderQty }})</li>
                           <li>{{ product.brand.id == 1 ? 'Certificaat' : 'Codekaart' }} voor het nabestellen</li>
                           <li>Handleiding</li>
                        </ul>
                        <div class="w-full md:w-1/2 mt-4 md:mt-0 bg-gray-50 rounded-xl px-4 py-2">
                           <strong>Sleutel meegeleverd per set</strong>
                           <div v-html="keys_table"></div>
                        </div>
                     </div>

                     <div class="mt-6 mb-4" v-if="product.key_price">
                        <h2 class="text-xl font-bold mb-4 inline-block">Sleutels</h2>

                        <div class="flex flex-wrap">
                           <div class="w-full">
                              <p class="mb-4">
                                 Standaard worden er totaal <strong>{{ keyQty }} sleutels</strong> geleverd bij
                                 <strong>{{ cylinderQty }} cilinder(s)</strong>. Het aantal gratis meegeleverde sleutels
                                 hangt af van het aantal gekozen cilinders. Daarnaast kunt u extra sleutels bestellen
                                 voor een meerprijs van <strong>{{ price(product.key_price.price) }}.</strong><br />
                              </p>
                           </div>
                        </div>
                     </div>
                  </div>

                  <!-- Nabestellen -->
                  <div class="mt-6 mb-4" v-if="product.relative_urls.reorder_keys">
                     <h2 class="text-xl font-bold mb-4 inline-block">Nabestellen</h2>
                     <p>
                        Het nabestellen van sleutels en/of cilinders voor {{ product.brand.name }}
                        {{ product.model }} is mogelijk met het certificaat.
                     </p>
                     <Link
                        :href="product.relative_urls.reorder_keys"
                        :title="product.brand.name + ' ' + product.model + 'sleutel(s) nabestellen'"
                        class="block w-fit link link my-1 inline-block'"
                        >{{ product.brand.name }} {{ product.model }} sleutel(s) nabestellen</Link
                     >
                     <Link
                        :href="product.relative_urls.reorder_cylinders"
                        :title="product.brand.name + ' ' + product.model + 'cilinder(s) nabestellen'"
                        class="block w-fit link link my-1 inline-block'"
                        >{{ product.brand.name }} {{ product.model }} cilinder(s) nabestellen</Link
                     >
                  </div>
                  <!-- Sluitplan -->
                  <div class="mt-6 mb-4" v-if="product.relative_urls.mks">
                     <h2 class="text-xl font-bold mb-4 inline-block">Sluitplan</h2>
                     <p>
                        {{ product.name }} kan ook geleverd worden als
                        <Link :href="product.relative_urls.mks" class="link">sluitplan</Link>. Zo kun je bijvoorbeeld
                        met een hoofdsleutel alle cilinders openen en met een andere sleutel alleen de poort.
                     </p>
                  </div>

                  <div class="border-gray-300 rounded-lg p-8 mt-8 border flex" v-if="product.reorder_type != 2">
                     <div class="w-full md:w-2/3">
                        <h2 class="text-xl font-bold mb-4 inline-block">Cilinder opmeten</h2>

                        <p class="text-gray-600 md:pr-8">
                           Meet de huidige cilinder op vanaf het midden van het schroefgat. Let op: Een cilinder mag aan
                           de buitenzijde van de deur
                           <strong>max. 3 mm uitsteken</strong>.
                        </p>
                     </div>

                     <div class="w-1/2 md:w-1/3 flex justify-center">
                        <VuePicture
                           :image="{
                              src: asset('img/cilindermaat-bepalen-zijdes.webp'),
                              origin_src: asset('img/cilindermaat-bepalen-zijdes.png'),
                           }"
                           name="Cilindermaat bepalen"
                           :width="224"
                           :height="217"
                           :style="'w-40'"
                        />
                     </div>
                  </div>

                  <!-- Technische tekeningen -->
                  <div id="tekeningen" class="pb-6 mb-6 border-gray-200 mt-12" v-if="Object.keys(techimages).length">
                     <div class="w-full mb-6">
                        <h2 class="text-xl font-bold mb-4">Technische tekeningen</h2>
                     </div>

                     <div class="w-full flex flex-wrap">
                        <div class="w-1/2 pr-2">
                           <div class="text-center border p-4 rounded-xl h-full">
                              <strong class="mb-4 block">Standaard cilinder</strong>
                              <vue-picture
                                 :image="techimages.techCylinder"
                                 :name="'Technische tekening standaard cilinder'"
                                 :width="650"
                                 :height="650"
                                 fp
                              />
                           </div>
                        </div>
                        <div class="w-1/2 text-center border p-4 rounded-xl h-full">
                           <strong class="mb-4 block">Sleutel</strong>
                           <vue-picture
                              :image="techimages.techKey"
                              :name="'Technische tekening sleutel'"
                              :width="650"
                              :height="650"
                           />
                        </div>
                     </div>
                  </div>

                  <div
                     id="uitvoeringen"
                     class="pb-6 mb-6 border-gray-200 styled md:pr-8 mt-12"
                     v-if="isCylinder(product) || product.reorder_type == 1"
                  >
                     <div class="w-full mb-6">
                        <h2>Uitvoeringen</h2>
                     </div>
                     <div class="flex flex-wrap">
                        <div class="w-full flex flex-wrap items-center mb-6">
                           <div class="w-1/3 lg:w-1/3 pr-2 md:pr-8 flex justify-end">
                              <img
                                 :src="asset('img/config-cilinders/mc/dubbel.png')"
                                 v-if="product.brand_id == 1"
                                 class="w-auto"
                                 height="390"
                                 width="250"
                                 alt="Hele cilinder"
                                 loading="lazy"
                                 fetchpriority="low"
                              />
                              <img
                                 :src="asset('img/config-cilinders/default/dubbel.png')"
                                 v-else
                                 alt="Hele cilinder"
                                 class="max-h-32 w-auto"
                                 eight="390"
                                 width="250"
                                 loading="lazy"
                                 fetchpriority="low"
                              />
                           </div>
                           <div class="w-2/3 lg:w-2/3 px-4">
                              <strong>Hele cilinder</strong>
                              <p v-html="text_blocks['hele-cilinder']" />
                           </div>
                        </div>

                        <div class="w-full flex flex-wrap items-center mb-6">
                           <div class="w-1/3 lg:w-1/3 pr-2 md:pr-8 flex justify-end">
                              <img
                                 :src="asset('img/config-cilinders/mc/half.png')"
                                 v-if="product.brand_id == 1"
                                 class="max-h-32 w-auto"
                                 height="250"
                                 width="255"
                                 alt="Halve cilinder"
                                 loading="lazy"
                                 fetchpriority="low"
                              />
                              <img
                                 :src="asset('img/config-cilinders/default/half.png')"
                                 v-else
                                 alt="Halve cilinder"
                                 class="max-h-32 w-auto"
                                 height="250"
                                 width="255"
                                 loading="lazy"
                                 fetchpriority="low"
                              />
                           </div>
                           <div class="w-2/3 lg:w-2/3 px-4">
                              <strong>Halve cilinder</strong>
                              <p v-html="text_blocks['halve-cilinder']" />
                           </div>
                        </div>

                        <div class="w-full flex flex-wrap items-center mb-6">
                           <div class="w-1/3 lg:w-1/3 pr-2 md:pr-8 flex justify-end">
                              <img
                                 :src="asset('img/config-cilinders/mc/knop.png')"
                                 v-if="product.brand_id == 1"
                                 class="max-h-32 w-auto"
                                 height="250"
                                 width="489"
                                 alt="Knopcilinder"
                                 loading="lazy"
                                 fetchpriority="low"
                              />
                              <img
                                 :src="asset('img/config-cilinders/default/knop.png')"
                                 v-else
                                 alt="Knopcilinder"
                                 class="max-h-32 w-auto"
                                 height="250"
                                 width="502"
                                 loading="lazy"
                                 fetchpriority="low"
                              />
                           </div>
                           <div class="w-2/3 lg:w-2/3 px-4">
                              <strong>Knopcilinder</strong>
                              <p v-html="text_blocks.knopcilinder" />
                           </div>
                        </div>

                        <div class="w-full flex flex-wrap items-center mb-6">
                           <div class="w-1/3 lg:w-1/3 pr-2 md:pr-8 flex justify-end">
                              <img
                                 :src="asset('img/config-cilinders/mc/half-knop.png')"
                                 v-if="product.brand_id == 1"
                                 class="max-h-32 w-auto"
                                 height="250"
                                 width="354"
                                 alt="Halve knopcilinder"
                                 loading="lazy"
                                 fetchpriority="low"
                              />
                              <img
                                 :src="asset('img/config-cilinders/default/half-knop.png')"
                                 v-else
                                 alt="Halve knopcilinder"
                                 class="max-h-32 w-auto"
                                 height="250"
                                 width="367"
                                 loading="lazy"
                                 fetchpriority="low"
                              />
                           </div>
                           <div class="w-2/3 lg:w-2/3 px-4">
                              <strong>Halve knopcilinder</strong>
                              <p v-html="text_blocks['halve-knop-cilinder']" />
                           </div>
                        </div>
                     </div>
                  </div>
               </div>

               <!-- Reviews -->
               <div class="w-full md:w-1/2 my-2 md:border-l border-gray-200 px-0 md:px-8 mt-8 md:mt-2">
                  <div class="w-full" id="product-reviews" v-if="product.reviews.reviews.length">
                     <ProductReviews :slug="product.slug" :reviews="product.reviews" />
                  </div>

                  <div class="mt-8 flex flex-wrap" v-if="specifications.groups.length > 1">
                     <strong class="pl-3 uppercase text-sm">Veiligheidskenmerken</strong>
                     <table class="w-full">
                        <tbody>
                           <ProductSpecsValue
                              v-for="(option, index) in specifications.groups[1].attribute"
                              :key="option.id"
                              :option="option"
                              :gray="index % 2 !== 0"
                           />
                        </tbody>
                     </table>
                     <button @click="$scrollTo('#specs', 500)" class="button default mx-auto mt-6 h-12">
                        Bekijk alle specificaties
                     </button>
                  </div>

                  <!-- Kleuren -->
                  <div id="kleuren" class="pb-6 mb-6 border-b border-gray-200 mt-12" v-if="options.colors.length > 1">
                     <div class="w-full mb-6 styled">
                        <h2>Kleuren</h2>
                        <div v-html="text_blocks.kleuren"></div>
                     </div>
                     <ul class="flex flex-wrap">
                        <li class="flex flex-col items-center justify-center w-1/3">
                           <span>
                              <strong>Nikkel</strong>
                           </span>
                           <vue-picture
                              :image="versionimages.cylinderDubble"
                              :width="250"
                              :height="250"
                              :name="'Nikkel'"
                              :style="'max-h-48'"
                              alt="Dubbel cilinder"
                           />
                        </li>
                        <li class="flex flex-col items-center justify-center w-1/3">
                           <span>
                              <strong>Messing</strong>
                              <span class="text-gray-500 md:ml-2 block md:inline-block">+ € 3,00</span>
                           </span>
                           <vue-picture
                              :image="colorImages.brass"
                              :width="250"
                              :height="250"
                              :name="'Messing'"
                              :style="'max-h-48'"
                              alt="Messing cilinder"
                           />
                        </li>
                        <li class="flex flex-col items-center justify-center w-1/3">
                           <span>
                              <strong>Zwart</strong>
                              <span class="text-gray-500 md:ml-2 block md:inline-block">+ € 3,00</span>
                           </span>
                           <vue-picture
                              :image="colorImages.black"
                              :width="250"
                              :height="250"
                              :name="'Zwart'"
                              :style="'max-h-48'"
                              alt="Zwarte cilinder"
                           />

                           <!-- <span class="bg-black h-5 w-5 rounded-full inline-block float-left mt-0.5 mr-2"></span> -->
                        </li>
                     </ul>
                  </div>

                  <!-- Knoppen -->
                  <div id="knoppen" class="pb-6 border-gray-200 styled" v-if="options.buttons.length > 1">
                     <div class="w-full mb-6">
                        <h2>Knoppen</h2>
                        <div v-html="text_blocks.introknoppen"></div>
                     </div>

                     <div class="flex flex-wrap" v-if="options.buttons && options.buttons.length">
                        <div v-for="button in filteredButtons" :key="button.id" class="w-1/2 md:w-1/3 flex flex-wrap">
                           <option-card :option="button" />
                        </div>
                     </div>
                  </div>

                  <!-- Smartlock adapters -->
                  <div id="knoppen" class="pb-6 border-gray-200 styled" v-if="options.smartlock_adapters.length > 1">
                     <div class="w-full mb-6">
                        <h2>Smartlock adapters</h2>
                        <div v-html="text_blocks['smartlock-adapters']"></div>
                     </div>

                     <div class="flex flex-wrap" v-if="options.smartlock_adapters && options.smartlock_adapters.length">
                        <div
                           v-for="adapter in options.smartlock_adapters"
                           :key="adapter.id"
                           class="w-1/2 md:w-1/3 flex flex-wrap"
                        >
                           <option-card :option="adapter" />
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>

         <ProductSpecs :product="product" :options="specifications" class="pb-6 mb-6 styled"></ProductSpecs>

         <div id="faq">
            <Faqs :faqs="product.faq" />
         </div>
      </div>
   </div>
   <teleport to="#modals">
      <modal title="" ref="modal">
         <template v-slot:content>
            <img :src="data.optionImage" />
         </template>
      </modal>
   </teleport>
</template>

<script setup>
import OptionCard from '@/Components/OptionCard.vue';
import ProductReviews from '@/Components/ProductReviews.vue';
import ProductSpecs from '@/Components/ProductSpecs.vue';
import ProductSpecsValue from '@/Components/ProductSpecsValue.vue';
import Faqs from '@/Components/Service/Faqs.vue';
import { computed, reactive, ref } from 'vue';
import { Collapse } from 'vue-collapsed';

const isExpanded = ref(false);

const props = defineProps({
   product: Object,
   options: Object,
   specifications: Object,
   versionimages: Object,
   colorImages: Object,
   techimages: Object,
   text_blocks: Object,
   keys_table: [String, Boolean],
   cylinderQty: Number,
   keyQty: Number,
});

const data = reactive({
   optionImage: false,
   showModal: false,
});

const filteredButtons = computed(function () {
   return props.options.buttons.filter(function (button) {
      return !button.value.includes('Zonder') && !button.value.includes('Geen') && ![2, 3].includes(button.color);
   });
});

function isCylinder(product) {
   return !product.reorder_type == 1 && product.type == 'configurable';
}
</script>
